module.exports = __webpack_public_path__ + "img/chevron-back-outline.a966ecee.svg";